import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMetaAds = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4829_173199)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M4.57292 2.68408C4.56755 2.68408 4.56284 2.68408 4.55746 2.68408L4.53662 4.41854C4.54133 4.41854 4.54603 4.41854 4.55074 4.41854C5.69225 4.41854 6.57763 5.3187 8.50301 8.56106L8.62065 8.7587L8.62805 8.77148L9.7057 7.15467L9.6983 7.1419C9.44486 6.7298 9.20082 6.34996 8.96755 6.00375C8.69662 5.6024 8.4378 5.24341 8.18637 4.92341C6.91242 3.3019 5.84687 2.68408 4.57292 2.68408Z",
				fill: "url(#paint0_linear_4829_173199)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.55747 2.68408C3.2768 2.6908 2.1447 3.51837 1.32722 4.78559C1.32453 4.78963 1.32251 4.79299 1.31982 4.79702L2.82033 5.61383C2.82302 5.61047 2.82503 5.60644 2.82772 5.60307C3.30503 4.88442 3.89932 4.42593 4.53596 4.41921C4.54066 4.41921 4.54537 4.41921 4.55008 4.41921L4.57226 2.68475C4.56688 2.68475 4.56218 2.68475 4.5568 2.68475L4.55747 2.68408Z",
				fill: "url(#paint1_linear_4829_173199)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.32746 4.78687C1.32477 4.7909 1.32275 4.79426 1.32006 4.79829C0.782918 5.6346 0.382246 6.66048 0.165775 7.76771C0.165103 7.77241 0.163758 7.77712 0.163086 7.78182L1.84914 8.17981C1.84981 8.1751 1.85115 8.17039 1.85183 8.16569C2.03199 7.19292 2.37485 6.29073 2.82056 5.61577C2.82325 5.61241 2.82527 5.60838 2.82796 5.60502L1.32746 4.78821V4.78687Z",
				fill: "url(#paint2_linear_4829_173199)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.85194 8.16507L0.16656 7.76709C0.165888 7.7718 0.164543 7.7765 0.163871 7.78121C0.0455515 8.39096 -0.0142805 9.00944 -0.015625 9.62927C-0.015625 9.63398 -0.015625 9.63936 -0.015625 9.64406L1.71345 9.79869C1.71345 9.79398 1.71345 9.7886 1.71345 9.7839C1.71278 9.74759 1.71211 9.71129 1.71211 9.67432C1.71278 9.1728 1.75917 8.67264 1.84992 8.17919C1.85059 8.17448 1.85194 8.16978 1.85261 8.16507H1.85194Z",
				fill: "url(#paint3_linear_4829_173199)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M1.76589 10.3358C1.73496 10.1576 1.71748 9.97745 1.71345 9.79661C1.71345 9.7919 1.71345 9.78653 1.71345 9.78182L-0.015625 9.6272C-0.015625 9.6319 -0.015625 9.63728 -0.015625 9.64199C-0.015625 10.0292 0.0166439 10.3902 0.0791649 10.7243C0.0798372 10.729 0.0811817 10.7338 0.081854 10.7385L1.76858 10.3506C1.7679 10.3459 1.76656 10.3411 1.76589 10.3364V10.3358Z",
				fill: "url(#paint4_linear_4829_173199)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2.15977 11.2332C1.97154 11.0281 1.83843 10.7317 1.76851 10.3525C1.76784 10.3478 1.7665 10.3431 1.76582 10.3384L0.0791016 10.7263C0.0797738 10.731 0.0811184 10.7357 0.0817906 10.7404C0.209522 11.41 0.459606 11.9673 0.817253 12.3895C0.820614 12.3935 0.823303 12.3969 0.826665 12.4009L2.16919 11.2439C2.16582 11.2406 2.16246 11.2365 2.1591 11.2332H2.15977Z",
				fill: "url(#paint5_linear_4829_173199)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M7.1559 6.43384C6.13943 7.99283 5.52363 8.97031 5.52363 8.97031C4.16968 11.0927 3.70111 11.5686 2.9475 11.5686C2.63288 11.5686 2.37002 11.4564 2.16901 11.2426C2.16565 11.2392 2.16229 11.2352 2.15893 11.2318L0.816406 12.3888C0.819768 12.3928 0.822457 12.3962 0.825818 12.4002C1.31994 12.9764 2.01775 13.2964 2.88162 13.2964C4.18783 13.2964 5.12699 12.6806 6.79691 9.76157C6.79691 9.76157 7.49271 8.53199 7.97204 7.6856C7.67557 7.20695 7.40531 6.79216 7.1559 6.43451V6.43384Z",
				fill: "#0082FB"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.96758 3.97485C8.96422 3.97821 8.96086 3.98225 8.9575 3.98561C8.6906 4.26998 8.43447 4.58729 8.18506 4.92477C8.43649 5.24477 8.69598 5.60443 8.96691 6.00578C9.28623 5.513 9.58405 5.11368 9.87649 4.80779C9.87985 4.80443 9.88321 4.8004 9.88657 4.79704L8.96758 3.97485Z",
				fill: "url(#paint6_linear_4829_173199)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.9024 3.82022C13.1938 3.10425 12.3487 2.68408 11.4452 2.68408C10.4926 2.68408 9.69127 3.20644 8.96858 3.97349C8.96522 3.97686 8.96186 3.98089 8.9585 3.98425L9.87816 4.80576C9.88152 4.8024 9.88488 4.79837 9.88824 4.79501C10.3642 4.29954 10.8254 4.05215 11.3363 4.05215C11.8862 4.05215 12.4012 4.31097 12.8469 4.76475C12.8503 4.76812 12.8536 4.77215 12.8577 4.77551L13.9145 3.83097C13.9111 3.82761 13.9071 3.82358 13.9037 3.82022H13.9024Z",
				fill: "#0082FB"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.9511 9.39923C15.9114 7.10007 15.1067 5.04427 13.9128 3.83082C13.9094 3.82746 13.9054 3.82343 13.902 3.82007L12.8452 4.76461C12.8486 4.76797 12.8519 4.772 12.856 4.77536C13.7541 5.69839 14.3706 7.41469 14.4264 9.39856C14.4264 9.40326 14.4264 9.40864 14.4264 9.41335H15.9511C15.9511 9.40864 15.9511 9.40393 15.9511 9.39856V9.39923Z",
				fill: "url(#paint7_linear_4829_173199)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.9514 9.41542C15.9514 9.41072 15.9514 9.40534 15.9514 9.40063H14.4267C14.4267 9.40534 14.4267 9.41005 14.4267 9.41542C14.4293 9.50887 14.43 9.60232 14.43 9.69643C14.43 10.2376 14.3493 10.6746 14.1846 10.9899C14.182 10.9946 14.1799 10.9993 14.1772 11.004L15.3141 12.1865C15.3167 12.1825 15.3194 12.1778 15.3228 12.1737C15.7356 11.5371 15.952 10.6524 15.952 9.57946C15.952 9.525 15.952 9.47055 15.9507 9.4161L15.9514 9.41542Z",
				fill: "url(#paint8_linear_4829_173199)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M14.1857 10.9872C14.183 10.992 14.181 10.9967 14.1783 11.0014C14.0364 11.2676 13.8334 11.4451 13.5679 11.5224L14.0862 13.156C14.1548 13.1325 14.2213 13.1062 14.2865 13.0773C14.306 13.0686 14.3255 13.0598 14.3443 13.0504C14.3551 13.0451 14.3665 13.0397 14.3773 13.0343C14.7201 12.8635 15.0099 12.6114 15.2438 12.2867C15.258 12.2672 15.2721 12.2471 15.2862 12.2269C15.2963 12.2128 15.3057 12.198 15.3151 12.1832C15.3178 12.1792 15.3205 12.1745 15.3238 12.1704L14.1857 10.9866V10.9872Z",
				fill: "url(#paint9_linear_4829_173199)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.2382 11.5667C13.0648 11.5667 12.9108 11.5411 12.7609 11.4739L12.2305 13.1458C12.529 13.248 12.8469 13.2937 13.2019 13.2937C13.5286 13.2937 13.8291 13.2446 14.1007 13.1505L13.5824 11.5176C13.4708 11.5512 13.3545 11.5673 13.2382 11.5667Z",
				fill: "url(#paint10_linear_4829_173199)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.1757 10.9965C12.1724 10.9925 12.169 10.9891 12.1657 10.9851L10.9448 12.255C10.9482 12.2584 10.9515 12.2624 10.9549 12.2658C11.3791 12.7182 11.7845 12.9986 12.2436 13.1525L12.7741 11.4812C12.5805 11.3979 12.3929 11.2473 12.1757 10.9959V10.9965Z",
				fill: "url(#paint11_linear_4829_173199)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.1663 10.9845C11.7999 10.5583 11.3468 9.84968 10.6342 8.70279L9.70516 7.15389L9.69776 7.14111L8.62012 8.75725L8.62751 8.77002L9.28566 9.87725C9.92365 10.9448 10.4433 11.7172 10.9448 12.2544C10.9482 12.2578 10.9515 12.2618 10.9549 12.2651L12.1757 10.9959C12.1724 10.9919 12.169 10.9885 12.1657 10.9845H12.1663Z",
				fill: "url(#paint12_linear_4829_173199)"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_4829_173199",
			x1: 8.98906,
			y1: 8.11333,
			x2: 5.41191,
			y2: 3.42627,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#0867DF" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .45,
					stopColor: "#0668E1"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .86,
					stopColor: "#0064E0"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_4829_173199",
			x1: 2.02503,
			y1: 5.07736,
			x2: 4.47747,
			y2: 3.21517,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .13,
				stopColor: "#0064DF"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0064E0"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_4829_173199",
			x1: .985271,
			y1: 7.81006,
			x2: 1.96947,
			y2: 5.33409,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .01,
				stopColor: "#0072EC"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .69,
				stopColor: "#0064DF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_4829_173199",
			x1: .852274,
			y1: 9.59969,
			x2: .965888,
			y2: 8.08776,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .07,
				stopColor: "#007CF6"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .99,
				stopColor: "#0072EC"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint4_linear_4829_173199",
			x1: .914795,
			y1: 10.4191,
			x2: .833451,
			y2: 9.81274,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .07,
				stopColor: "#007FF9"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#007CF6"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint5_linear_4829_173199",
			x1: .867001,
			y1: 10.5804,
			x2: 1.37456,
			y2: 11.656,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .07,
				stopColor: "#007FF9"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0082FB"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint6_linear_4829_173199",
			x1: 8.66573,
			y1: 5.37317,
			x2: 9.33666,
			y2: 4.44544,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .28,
				stopColor: "#007FF8"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: .91,
				stopColor: "#0082FB"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint7_linear_4829_173199",
			x1: 13.7656,
			y1: 4.1683,
			x2: 15.1692,
			y2: 9.33066,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0082FB" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0081FA"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint8_linear_4829_173199",
			x1: 15.5083,
			y1: 9.53038,
			x2: 14.6203,
			y2: 11.3247,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .06,
				stopColor: "#0081FA"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0080F9"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint9_linear_4829_173199",
			x1: 13.9141,
			y1: 12.274,
			x2: 14.7443,
			y2: 11.7086,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#027AF3" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0080F9"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint10_linear_4829_173199",
			x1: 12.6123,
			y1: 12.3841,
			x2: 13.7659,
			y2: 12.3841,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0377EF" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0279F1"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint11_linear_4829_173199",
			x1: 11.609,
			y1: 11.7501,
			x2: 12.4386,
			y2: 12.2382,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#0471E9" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0377EF"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint12_linear_4829_173199",
			x1: 9.07928,
			y1: 8.15153,
			x2: 11.7361,
			y2: 11.492,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", {
				offset: .28,
				stopColor: "#0867DF"
			}), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#0471E9"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_4829_173199",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 16,
				height: 16,
				fill: "white"
			})
		})
	] })]
});
export default SvgMetaAds;
